<template>
  <Modal :show="show" role="alertdialog" size="lg">
    <form
      @submit.prevent="handleConfirm"
      class="mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden"
    >
      <slot>
        <ModalHeader v-if="mode==='remove'" v-text="__(`${uppercaseMode} Core`)" />
        <ModalHeader v-else v-text="__(`${uppercaseMode} Core`)" />
        <ModalContent>
            <p class="leading-normal" v-if="mode==='remove'">
                {{ __('Are you sure you want to mark this core as picked-up for this sale order?') }}
            </p>
            <p class="leading-normal" v-else>
                {{ __('Are you sure you want to ' + mode + ' this resource?') }}
            </p>
        </ModalContent>
      </slot>

        <div class="px-8 pb-8" v-if="mode==='remove'">
            <label for="reason" class="inline-block text-80 pt-2 leading-tight mb-2">Reason:
                <span class="text-danger text-sm"> *</span>
            </label>
            <textarea
                id="reason"
                type="text"
                style="height: 150px; resize: none"
                v-model="reason"
                :class="{ 'border-red-500': reasonError }"
                :maxlength="maxReasonLength"
                :minlength="minReasonLength"
                class="w-full form-control form-input form-input-bordered py-2"
            />
            <small class="text-muted">(Reason should be between 20 and 250 characters.)</small>
            <span v-if="reasonError" class="text-red-500 text-sm">{{ reasonError }}</span>
        </div>

      <ModalFooter>
        <div class="ml-auto">
          <LinkButton
            type="button"
            dusk="cancel-delete-button"
            @click.prevent="handleClose"
            class="mr-3"
          >
            {{ __('Cancel') }}
          </LinkButton>

          <Button
            type="submit"
            ref="confirmButton"
            dusk="confirm-delete-button"
            :disabled="reason.length < minReasonLength || reason.length > maxReasonLength"
            :loading="working"
            state="danger"
            :label="__(uppercaseMode)"
          />
        </div>
      </ModalFooter>
    </form>
  </Modal>
</template>

<script>
import startCase from 'lodash/startCase'
import { Button } from 'laravel-nova-ui'

export default {
  components: {
    Button,
  },

  emits: ['confirm', 'close'],

  props: {
    show: { type: Boolean, default: false },

    mode: {
      type: String,
      default: 'delete',
      validator: function (value) {
        return ['force delete', 'remove', 'delete', 'detach'].indexOf(value) !== -1
      },
    },
  },

  data: () => ({
    working: false,
      reason: '',
      reasonError: '',
      minReasonLength: 20, // Set the minimum reason length
      maxReasonLength: 250,
  }),

  watch: {
    show(showing) {
      if (showing === false) {
        this.working = false
      }
    },
  },

  methods: {
    handleClose() {
      this.$emit('close')
      this.working = false
    },

    handleConfirm() {
        if (this.reason.length < this.minReasonLength || this.reason.length > this.maxReasonLength) {
            this.reasonError = `Reason should be between ${this.minReasonLength} and ${this.maxReasonLength} characters.`;
            return;
        }
        this.reasonError = '';
        this.$emit('confirm', this.reason)
      this.working = true
    },
  },

  /**
   * Mount the component.
   */
  mounted() {
    this.$nextTick(() => {
      // this.$refs.confirmButton.button.focus()
    })
  },

  computed: {
    uppercaseMode() {
      return startCase(this.mode)
    },
  },
}
</script>
